import { render, staticRenderFns } from "./see.vue?vue&type=template&id=23987ece&scoped=true&"
import script from "./see.vue?vue&type=script&lang=js&"
export * from "./see.vue?vue&type=script&lang=js&"
import style0 from "./see.vue?vue&type=style&index=0&id=23987ece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23987ece",
  null
  
)

export default component.exports